import React, { useEffect, useState } from "react"
import { IMG } from "../common/CONST"
import { useStore } from "../../stores/RootStoreContext"
import * as TrinityAPI from "../../requests/TrinityAPI"
import { Link } from "react-router-dom"
import {
  ADMIN_COMPANY_ROUTE,
  ADMIN_RATE_SETTINGS_ROUTE,
  ADMIN_USER_ROUTE,
  BALANCE_ROUTE,
  CURRENCY_EXCHANGE_ROUTE,
  CURRENCY_REPLENISHMENT_ROUTE,
  DASHBOARD_ROUTE,
  ORDER_ROUTE,
  RATES_ROUTE,
  REPLENISHMENT_ROUTE,
  REQUEST_ROUTE
} from "../../routes"
import { CONFIG } from "../../CONFIG"
import { useInstancesStore } from "@/stores/instancesStore"
import Button from "@/ui/components/Button"
import { useUnreadStore } from "@/stores/unreadStore"

export const MenuAdmin: React.FC<{ active: string }> = ({ active }) => {
  const { userStore } = useStore()

  const { unreadList, setUnreadList } = useUnreadStore()
  const { instancesList, setInstances } = useInstancesStore()

  const [isUpdating, setUpdating] = useState(false)

  const countMsgByType = (type: string): string => {
    let count = 0
    unreadList?.items.forEach(i => {
      count += i.type === type ? i.num : 0
    })
    return count > 0 ? count.toString() : ""
  }

  const countInstanceByType = (type: string) => {
    let count = 0
    instancesList?.items.forEach(i => {
      count += i.type === type ? i.num : 0
    })
    return count > 0 ? count.toString() : ""
  }

  const fetchUnread = () => {
    TrinityAPI.getUnreadConversations("", response => {
      if (response.status === 200) {
        setUnreadList(response.data)
      }
    })
    TrinityAPI.getActionsRequired(response => {
      if (response.status === 200) {
        setInstances(response.data)
      }
    })
  }

  const updateCurrencies = () => {
    setUpdating(true)

    Promise.all([TrinityAPI.updateCurrencyCbr(), TrinityAPI.updateCurrencyBca()]).finally(() => setUpdating(false))
  }

  if (!userStore.isAdmin) {
    userStore.setToken("")
    window.location.href = "/"
  }

  useEffect(() => {
    fetchUnread()

    const intervalId = setInterval(() => {
      fetchUnread()
    }, CONFIG.fetchUnreadsInterval)

    return () => {
      clearInterval(intervalId)
    }
  }, [])

  return (
    <header className="header">
      <Link to={DASHBOARD_ROUTE} className="logo-header">
        <img src={IMG.sign} alt="" className="logo-header-img" />
        <span>trinity</span>
      </Link>
      <nav className="header-nav">
        <div className="header-nav-list">
          <Link className={`header-nav-item${active === "dashboard" ? "-active" : ""}`} to={DASHBOARD_ROUTE}>
            <img src={IMG.home} alt="" className="header-nav-icon" />
            <div className="header-nav-title">Главная</div>
            <span className="span-actions">{countInstanceByType("INN")}</span>
          </Link>
          <Link className={`header-nav-item${active === "company" ? "-active" : ""}`} to={ADMIN_COMPANY_ROUTE}>
            <img src={IMG.companies} alt="" className="header-nav-icon" />
            <div className="header-nav-title">Зарубежные компании</div>
          </Link>
          <Link className={`header-nav-item${active === "request" ? "-active" : ""}`} to={REQUEST_ROUTE}>
            <img src={IMG.requests} alt="" className="header-nav-icon" />
            <div className="header-nav-title">Запросы</div>
            <span className="span-message">{countMsgByType("REQUEST")}</span>
            <span className="span-actions">{countInstanceByType("REQUEST")}</span>
          </Link>
          <Link className={`header-nav-item${active === "replenishment" ? "-active" : ""}`} to={REPLENISHMENT_ROUTE}>
            <img src={IMG.deals} alt="" className="header-nav-icon" />
            <div className="header-nav-title">Пополнения рублевые</div>
            <span className="span-message">{countMsgByType("REPLENISHMENT")}</span>
            <span className="span-actions">{countInstanceByType("REPLENISHMENT")}</span>
          </Link>
          <Link
            className={`header-nav-item${active === "currency-replenishment" ? "-active" : ""}`}
            to={CURRENCY_REPLENISHMENT_ROUTE}
          >
            <img src={IMG.deals} alt="" className="header-nav-icon" />
            <div className="header-nav-title">Пополнения валютные</div>
            <span className="span-message">{countMsgByType("CURREPLENISHMENT")}</span>
            <span className="span-actions">{countInstanceByType("CURREPLENISHMENT")}</span>
          </Link>
          <Link className={`header-nav-item${active === "order" ? "-active" : ""}`} to={ORDER_ROUTE}>
            <img src={IMG.orders} alt="" className="header-nav-icon" />
            <div className="header-nav-title">Ордера</div>
            <span className="span-message">{countMsgByType("ORDER")}</span>
            <span className="span-actions">{countInstanceByType("ORDER")}</span>
          </Link>
          <Link
            className={`header-nav-item${active === "manager" ? "-active" : ""}`}
            to={`${ADMIN_USER_ROUTE}?role=ROLE_MANAGER`}
          >
            <img src={IMG.profile} alt="" className="header-nav-icon" />
            <div className="header-nav-title">Менеджеры</div>
          </Link>
          <Link
            className={`header-nav-item${active === "client" ? "-active" : ""}`}
            to={`${ADMIN_USER_ROUTE}?role=ROLE_CLIENT`}
          >
            <img src={IMG.contr} alt="" className="header-nav-icon" />
            <div className="header-nav-title">Пользователи</div>
          </Link>
          <Link
            className={`header-nav-item${active === "rate-settings" ? "-active" : ""}`}
            to={ADMIN_RATE_SETTINGS_ROUTE}
          >
            <img src={IMG.filter_list} alt="" className="header-nav-icon" />
            <div className="header-nav-title">Настройки системы</div>
          </Link>
          <Link className={`header-nav-item${active === "rates" ? "-active" : ""}`} to={RATES_ROUTE}>
            <img src={IMG.exchange} alt="" className="header-nav-icon" />
            <div className="header-nav-title">Курсы валют</div>
          </Link>
          <Link
            className={`header-nav-item${active === "currencyExchange" ? "-active" : ""}`}
            to={CURRENCY_EXCHANGE_ROUTE}
          >
            <img src={IMG.exchange} alt="" className="header-nav-icon" />
            <div className="header-nav-title">Обмен валют</div>
          </Link>
          <Link className={`header-nav-item${active === "balance" ? "-active" : ""}`} to={BALANCE_ROUTE}>
            <img src={IMG.money_bag} alt="" className="header-nav-icon" />
            <div className="header-nav-title">Балансы</div>
          </Link>

          <Button variant="grey" className="header-nav-item-bottom" loading={isUpdating} onClick={updateCurrencies}>
            Обновить курсы
          </Button>
        </div>
      </nav>
    </header>
  )
}
